import { Box, Grid, Typography } from "@mui/material";

export const WellDataTab = ({ selectedTab, wellData, snapshot }) => {
  return (
    <Grid container width={"100%"}>
      {/* Middle: Well Data */}
      <Grid
        size={{ xs: 12, md: 12, lg: 6 }}
        sx={{
          bgcolor: "#374151",
          borderRight: "1px solid #a0a0a0ff",
          p: 2,
        }}
      >
        <Box sx={{ bgcolor: "#1e293b", px: 1, py: 0.5 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", fontSize: 14 }}
          >
            Well {selectedTab} Data
          </Typography>
        </Box>
        {wellData.map((item) => (
          <Box
            key={item.label}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 0.8,
              borderBottom: "1px solid #a0a0a0ff",
            }}
          >
            <Typography
              sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
            >
              {item.label}
            </Typography>
            <Typography
              sx={{
                color: "#c3daffff",
                fontWeight: "bold",
                fontSize: 13,
                backgroundColor:
                  item.label === "Status" && item.value !== "Normal Operation"
                    ? "red"
                    : "transparent",
                px:
                  item.label === "Status" && item.value !== "Normal Operation"
                    ? 2
                    : 0,
                py:
                  item.label === "Status" && item.value !== "Normal Operation"
                    ? 0.5
                    : 0,
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Grid>

      {/* Right: Snapshot */}
      <Grid size={{ xs: 12, md: 12, lg: 6 }} sx={{ bgcolor: "#374151", p: 2 }}>
        <Box sx={{ bgcolor: "#1e293b", px: 1, py: 0.5 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", fontSize: 14 }}
          >
            Well {selectedTab} Snapshot
          </Typography>
        </Box>
        {snapshot.map((item) => (
          <Box
            key={item.label}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 0.8,
              borderBottom: "1px solid #a0a0a0ff",
            }}
          >
            <Typography
              sx={{ color: "#ffffffff", fontWeight: 600, fontSize: 13 }}
            >
              {item.label}
            </Typography>
            <Typography
              sx={{ color: "#c3daffff", fontWeight: "bold", fontSize: 13 }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};
